import { Container } from "@/components/container";

export default function About() {
  return (
    <div>
      <section className="bg-secondary/50 border-b">
        <Container className="py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-semibold">About Pro Systems</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            We help Bangkok SMBs turn technology into a growth advantage with clear strategy,
            reliable execution, and responsive support.
          </p>
        </Container>
      </section>
      <Container className="py-12 md:py-16 grid gap-10 md:grid-cols-2">
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold">Our story</h2>
          <p className="text-muted-foreground">
            Founded in Bangkok, Pro Systems brings decades of combined experience across
            infrastructure, networking, cloud, and DevOps. We deliver enterprise-grade practices
            tailored to SMB realities—budgets, timelines, and local operational needs.
          </p>
          <p className="text-muted-foreground">
            Our approach is pragmatic: start with outcomes, plan for simplicity, and document
            everything. We believe in partnership over hand-offs and measure success by uptime,
            performance, security, and your team’s confidence.
          </p>
        </div>
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold">Leadership</h2>
          <p className="text-muted-foreground">
            Leadership profiles available upon request. We maintain a lean public profile while
            focusing on delivery and client success. References are available for qualified
            engagements.
          </p>
        </div>
      </Container>
    </div>
  );
}
